module.exports = __webpack_public_path__ + "static/media/internet.5fbbf7f0.svg";